import React, { useEffect, createElement } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
const META_PIXEL_ID = '1237593141556086';
function initMetaPixel() {
  if (typeof window === 'undefined') return;
  const w = window as any;
  if (w.fbq) return;
  // Inline the official Meta Pixel snippet via a script tag (verbatim).
  const inlineScript = document.createElement('script');
  inlineScript.text = `
    !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', '${META_PIXEL_ID}');
    fbq('track', 'PageView');
  `;
  document.head.appendChild(inlineScript);
  // <noscript> fallback pixel
  const img = document.createElement('img');
  img.height = 1;
  img.width = 1;
  img.style.display = 'none';
  img.src = 'https://www.facebook.com/tr?id=' + META_PIXEL_ID + '&ev=PageView&noscript=1';
  document.body.appendChild(img);
}
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { HomePage } from './pages/HomePage';
import { DegreeListingPage } from './pages/DegreeListingPage';
import { ExpandedFormPage } from './pages/ExpandedFormPage';
import { ResultsPage } from './pages/ResultsPage';
import { UniversityPage } from './pages/UniversityPage';
import { UMALandingPage } from './pages/UMALandingPage';
import { GTCLandingPage } from './pages/GTCLandingPage';
import { UAGCLandingPage } from './pages/UAGCLandingPage';
import { CCULandingPage } from './pages/CCULandingPage';
import { CollegesPage } from './pages/CollegesPage';
import { ThankYouPage } from './pages/ThankYouPage';
import { RequestInformationPage } from './pages/RequestInformationPage';
import { RequestInformationForm } from './pages/RequestInformationForm';
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage';
import { TermsAndConditionsPage } from './pages/TermsAndConditionsPage';
import { GuidePage } from './pages/GuidePage';
import { FindDegreesPage } from './pages/FindDegreesPage';
function AppContent() {
  const location = useLocation();
  // Hide global header on individual college pages (e.g. /colleges/global-tech-college or /colleges/global-tech-college/program)
  const isCollegeDetailPage = /^\/colleges\/[^/]+/.test(location.pathname) && location.pathname !== '/colleges';
  const isThankYouPage = location.pathname === '/thank-you';
  const isRequestInfoForm = location.pathname === '/request-information/form';
  const isFindDegreesPage = /^\/find-degrees\//i.test(location.pathname);
  const hideChrome = isCollegeDetailPage || isThankYouPage || isRequestInfoForm || isFindDegreesPage;
  // Initialize Meta Pixel once on mount
  useEffect(() => {
    initMetaPixel();
  }, []);
  // Track PageView on every route change
  useEffect(() => {
    const w = window as any;
    if (typeof window !== 'undefined' && w.fbq) {
      w.fbq('track', 'PageView');
    }
  }, [location.pathname]);
  return <div className="min-h-screen flex flex-col font-sans" data-id="element-0">
      {!hideChrome && <Header data-id="element-1" />}
      <Routes data-id="element-2">
        <Route path="/" element={<HomePage data-id="element-4" />} data-id="element-3" />
        <Route path="/form" element={<ExpandedFormPage data-id="element-6" />} data-id="element-5" />
        <Route path="/degree/:areaStudy/:program" element={<HomePage data-id="element-8" />} data-id="element-7" />
        <Route path="/degrees/:category" element={<DegreeListingPage data-id="element-10" />} data-id="element-9" />
        <Route path="/colleges" element={<CollegesPage data-id="element-12" />} data-id="element-11" />
        <Route path="/colleges/ultimate-medical-academy" element={<UMALandingPage data-id="element-14" />} data-id="element-13" />
        <Route path="/colleges/global-tech-college" element={<GTCLandingPage data-id="element-16" />} data-id="element-15" />
        <Route path="/colleges/university-of-arizona-global-campus" element={<UAGCLandingPage data-id="element-18" />} data-id="element-17" />
        <Route path="/colleges/colorado-christian-university" element={<CCULandingPage data-id="element-20" />} data-id="element-19" />
        <Route path="/colleges/:universitySlug" element={<UniversityPage data-id="element-22" />} data-id="element-21" />
        <Route path="/colleges/:universitySlug/:programSlug" element={<UniversityPage data-id="element-24" />} data-id="element-23" />
        <Route path="/results" element={<ResultsPage data-id="element-26" />} data-id="element-25" />
        <Route path="/thank-you" element={<ThankYouPage data-id="element-28" />} data-id="element-27" />
        <Route path="/request-information" element={<RequestInformationPage data-id="element-30" />} data-id="element-29" />
        <Route path="/request-information/form" element={<RequestInformationForm data-id="element-32" />} data-id="element-31" />
        <Route path="/guide/:slug" element={<GuidePage data-id="element-34" />} data-id="element-33" />
        <Route path="/find-degrees/:template" element={<FindDegreesPage data-id="element-36" />} data-id="element-35" />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage data-id="element-38" />} data-id="element-37" />
        <Route path="/terms-and-conditions" element={<TermsAndConditionsPage data-id="element-40" />} data-id="element-39" />
        <Route path="*" element={<HomePage data-id="element-42" />} data-id="element-41" />
      </Routes>
      {!hideChrome && <Footer data-id="element-43" />}
    </div>;
}
export function App() {
  return <Router data-id="element-44">
      <AppContent data-id="element-45" />
    </Router>;
}